import { useState } from 'react';
import ReactDOM from 'react-dom';
import { usePopper } from 'react-popper';

import clsx from 'clsx';

//hooks
import useToggle from '@/utils/hooks/utils/useToggle';

import PropTypes from 'prop-types';

//components
import CustomPopover from '@/components/composite/Popover/CustomPopover';

const RecipientCell = ({ value }) => {
    const emails = value ? value : [];
    // Popover
    const { isOpen: isPopoverOpen, toggle: togglePopover } = useToggle();
    const [referenceElement, setReferenceElement] = useState();
    const [popperElement, setPopperElement] = useState();
    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        placement: 'bottom-start',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [-5, 8]
                }
            }
        ]
    });

    return (
        <div className="flex items-center space-x-2">
            {emails?.length ? (
                <span
                    className={clsx(
                        'leading-wide truncate rounded-m bg-icoBlue-100 px-3 py-2 text-xs text-icoBlue-400 dark:bg-icoBlue/20 dark:text-icoBlue',
                        {
                            'flex-1': emails?.length > 1
                        }
                    )}>
                    {emails?.[0]?.toLowerCase()}
                </span>
            ) : null}

            {emails?.length > 1 ? (
                <button
                    ref={setReferenceElement}
                    onClick={togglePopover}
                    className={clsx(
                        'leading-wide rounded-m bg-icoBlue-100 px-3 py-2 text-xs text-icoBlue-400 dark:bg-icoBlue/20 dark:text-icoBlue'
                    )}>
                    {`+ ${emails?.length - 1}`}
                </button>
            ) : null}
            {isPopoverOpen
                ? ReactDOM.createPortal(
                      <CustomPopover
                          open={isPopoverOpen}
                          hasBtnClose={false}
                          hasArrow={false}
                          popperElement={popperElement}
                          setPopperElement={setPopperElement}
                          styles={styles}
                          width="w-48"
                          toggle={() => togglePopover(false)}
                          attributes={attributes}
                          wrapperClassName="z-3">
                          <div className="flex w-48 flex-col space-y-0.5 rounded-m p-1">
                              {emails?.slice(1)?.map((item, id) => (
                                  <span
                                      key={id}
                                      className="rounded-m bg-icoBlue-100 px-1 py-2 text-xs text-icoBlue-400 dark:bg-icoBlue/20 dark:text-icoBlue">
                                      {item}
                                  </span>
                              ))}
                          </div>
                      </CustomPopover>,
                      document.body
                  )
                : null}
        </div>
    );
};

RecipientCell.propTypes = {
    value: PropTypes.array
};

export default RecipientCell;
